import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/site";
import { Reveal } from "../motion";
import { SectionHead } from "../SectionHead";

const spans = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7"];

const Card = ({ s, i }) => (
  <Reveal delay={(i % 2) * 0.1} className={`${spans[i]} min-w-0`}>
    <Link to={s.to} data-testid={`service-card-${i + 1}`} className="group relative block h-[420px] overflow-hidden rounded-[var(--ngp-radius)] bg-[color:var(--ngp-ink)] text-white sm:h-[480px] lg:h-[520px]">
      <img src={s.img} alt={s.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-[1.4s] ease-[cubic-bezier(.2,.7,.2,1)] group-hover:scale-[1.06]" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1d1d1b] via-[#1d1d1b]/45 to-[#1d1d1b]/5 transition-opacity duration-500 group-hover:opacity-90" />
      <div className="absolute inset-x-0 top-0 flex items-start justify-between p-6 lg:p-8">
        <span className="font-display text-sm text-white/80">{s.n} / 04</span>
        <span className="grid h-12 w-12 place-items-center rounded-full bg-white/10 backdrop-blur-md transition-[background-color,transform,color] duration-500 group-hover:rotate-45 group-hover:bg-[color:var(--ngp-teal)] group-hover:text-[color:var(--ngp-ink)]">
          <ArrowUpRight size={20} aria-hidden="true" />
        </span>
      </div>
      <div className="absolute inset-x-0 bottom-0 p-6 lg:p-8">
        <h3 className="font-display text-3xl font-semibold leading-none sm:text-4xl">{s.title}</h3>
        <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/85 sm:text-base">{s.text}</p>
        <span className="mt-5 block h-px w-full origin-left scale-x-0 bg-[color:var(--ngp-teal)] transition-transform duration-700 group-hover:scale-x-100" />
      </div>
    </Link>
  </Reveal>
);

export const ServicesBento = () => (
  <section id="servizi" data-testid="services-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-36">
    <SectionHead index="01" eyebrow="Servizi" lines={["Quattro competenze,", "un solo partner."]}
      text="Dalla stampa su ogni formato e supporto fino agli allestimenti, alla creatività e ai gadget personalizzati." />
    <div className="mt-14 grid grid-cols-1 gap-4 lg:mt-20 lg:grid-cols-12 lg:gap-5">
      {SERVICES.map((s, i) => <Card key={s.title} s={s} i={i} />)}
    </div>
  </section>
);
